/**
 * @generated SignedSource<<1d73fd4129a5d9f95bfc45fc6614ec36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSteps_deliveryOptions$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryStep_deliveryOptions" | "CheckoutProgressReview_deliveryOptions" | "CheckoutReviewStep_deliveryOptions">;
  readonly " $fragmentType": "CheckoutSteps_deliveryOptions";
}>;
export type CheckoutSteps_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: CheckoutSteps_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSteps_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CheckoutSteps_deliveryOptions",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryStep_deliveryOptions"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutProgressReview_deliveryOptions"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewStep_deliveryOptions"
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "e8e39deb0f902b3a27b224ce76d27ffc";

export default node;
